"use strict";

exports.__esModule = true;
exports.getPathContainsPath = getPathContainsPath;
/**
 * Determines whether the given element path contains another element path.
 */
function getPathContainsPath(parent, candidate) {
  if (candidate.length < parent.length) {
    return false;
  }
  for (var i = 0; i < parent.length; i++) {
    if (parent[i] !== candidate[i]) {
      return false;
    }
  }
  return true;
}